import React from "react";
import { LayoutMain } from "@unisearch/theme/layout";
import { UKApplicationWeekPage } from "@modules/study/webinar/uk_application_week";

const UkAdmissionDay = () => {
  return (
    <LayoutMain
      title={`UK Application Week`}
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/uk-application-week`}
    >
      <UKApplicationWeekPage />
    </LayoutMain>
  );
};

export default UkAdmissionDay;
